// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import "./controllers";
import * as echarts from "echarts";
import "echarts/theme/dark";

window.echarts = echarts;

// Copy event ID to clipboard
window.copyEventId = function (element) {
  const eventId = element.getAttribute("data-event-id");

  navigator.clipboard
    .writeText(eventId)
    .then(() => {
      // Show success feedback
      const originalText = element.textContent;
      element.textContent = "Copied!";
      
      // Reset text after 2 seconds
      setTimeout(() => {
        element.textContent = originalText;
      }, 2000);
    })
    .catch((err) => {
      console.error("Failed to copy:", err);
    });
};

// Initialize dropdowns on page load
document.addEventListener("turbo:load", () => {
  // Handle dropdown toggles
  const dropdownToggles = document.querySelectorAll('[data-bs-toggle="dropdown"]');
  
  dropdownToggles.forEach(toggle => {
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      const dropdownMenu = toggle.nextElementSibling;
      
      // Close other dropdowns
      document.querySelectorAll('.dropdown-menu.show').forEach(menu => {
        if (menu !== dropdownMenu) {
          menu.classList.remove('show');
        }
      });
      
      // Toggle current dropdown
      dropdownMenu.classList.toggle('show');
    });
  });

  // Close dropdowns when clicking outside
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-bs-toggle="dropdown"]')) {
      document.querySelectorAll('.dropdown-menu.show').forEach(menu => {
        menu.classList.remove('show');
      });
    }
  });

  // Handle sidebar toggle
  const sidebarToggles = document.querySelectorAll('[data-bs-toggle="minimize"]');
  sidebarToggles.forEach(toggle => {
    toggle.addEventListener('click', () => {
      const sidebar = document.querySelector('.sidebar');
      sidebar?.classList.toggle('active');
    });
  });
});

// Reinitialize Chartkick charts after Turbo frame renders
document.addEventListener("turbo:frame-render", (event) => {
  if (window.Chartkick) {
    // Small delay to ensure DOM is ready
    setTimeout(() => {
      // Find all chart elements in the rendered frame and create new charts
      const frame = event.target;
      const chartScripts = frame.querySelectorAll(
        'script[type="text/javascript"]'
      );

      chartScripts.forEach((script) => {
        // Re-execute the chart script
        const newScript = document.createElement("script");
        newScript.textContent = script.textContent;
        script.parentNode.replaceChild(newScript, script);
      });
    }, 50);
  }
});
